document.addEventListener("DOMContentLoaded", async function () {
  // Mapa tylko po polsku, pierwszy pasujący wygrywa
  const mapaKolorow = [
    ["biel", "#FFFFFF"],
    ["neon", "#EAC7D0"],
    ["klasycz", "#D9B5B8"],
    ["jasny", "#CF9B63"],
    ["średni", "#966C43"],
    ["ciemny", "#775039"],
    ["soczy", "#E99B67"],
    ["natural", "#E68F1A"],
    ["inten", "#FF8331"],
    ["pastel", "#C6DCCA"],
    ["morski", "#74C3CC"],
  ];

  const kolorDomyslny = "#ccc";
  const jezykBazowy = "pl";
  const selektor = ".hero__table__row";

  const wiersze = document.querySelectorAll(selektor);
  if (!wiersze.length) return;

  // Wiersze w języku bazowym (na stronie PL to po prostu bieżące)
  let bazowe = wiersze;

  if (!Shopify.locale.toLowerCase().startsWith(jezykBazowy)) {
    try {
      const root = Shopify.routes.root; // np. "/es/"
      let sciezka = location.pathname;
      if (root !== "/" && sciezka.startsWith(root)) {
        sciezka = "/" + sciezka.slice(root.length);
      }
      const res = await fetch(sciezka + location.search);
      const doc = new DOMParser().parseFromString(await res.text(), "text/html");
      bazowe = doc.querySelectorAll(selektor);
    } catch (e) {
      return;
    }
  }

  wiersze.forEach((wiersz, i) => {
    const tresc = wiersz.querySelector(".hero__table__cell--content p");
    const wzor = bazowe[i];
    if (!tresc || !wzor) return;

    const tytulPl = (wzor.querySelector(".hero__table__cell--title p")?.textContent || "").toLowerCase();
    const trescPl = (wzor.querySelector(".hero__table__cell--content p")?.textContent || "").toLowerCase();

    if (!tytulPl.includes("kolor")) return;

    const znaleziona = mapaKolorow.find(([fragment]) => trescPl.includes(fragment));
    tresc.style.setProperty("--dot-color", znaleziona ? znaleziona[1] : kolorDomyslny);
  });
});







// podmiana listy pionowej na poziome guziki

function markTagBlocks() {
  document.querySelectorAll('.wt-product__text-block__wrapper').forEach(function (wrapper) {
    var title = wrapper.querySelector('.wt-product__text-block__title');
    if (title && title.textContent.trim().toLowerCase() === 'tagi') {
      wrapper.classList.add('is-tags-block');
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', markTagBlocks);
} else {
  markTagBlocks();
}

document.addEventListener('shopify:section:load', markTagBlocks);




/* No i sierotki na razie nie ma czasu ale trzeba się z tym zmierzyć - propozyszyn :)
document.addEventListener('DOMContentLoaded', function() {
  // Spójniki i reszta hłamu
  const sierotki = /(^|\s)([aiouwz]|do|na|po|za|ze|od|to|że|by|co|bo|aż|ku|nad|pod|przy|dla|lub|albo|oraz|czy|ale|już|nie)\s/gi;
  
  // Selektory miejsc gdzie zaatakować
  const selektory = [
    'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li',
    '.skladnik-item__opis', '.skladnik-item__nazwa',
    '.product__description', '.product-description',
    '.rte', '.metafield-rich_text_field'
  ].join(', ');
  
  document.querySelectorAll(selektory).forEach(element => {
    // jak coś ma kod odpuszczamy
    if (element.querySelector('code, pre, script, style')) return;
    
    // Iterujemy po węzłach tekstowych
    const przechodnik = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
    const wezlyTekstowe = [];
    let wezel;
    while ((wezel = przechodnik.nextNode())) {
      wezlyTekstowe.push(wezel);
    }
    
    wezlyTekstowe.forEach(wezelTekstowy => {
      const zamieniony = wezelTekstowy.nodeValue.replace(sierotki, '$1$2\u00A0');
      if (zamieniony !== wezelTekstowy.nodeValue) {
        wezelTekstowy.nodeValue = zamieniony;
      }
    });
  });
});
*/


